import { SettingsCustomFormFieldData } from '../../../models/settings/settings-custom-form-field-data.class';
import { FieldDataInterface } from '../../../models/settings/settings-custom-form-field-data.model';

export class SettingsDropdownSelectorV1Field extends SettingsCustomFormFieldData {

    public values: Array<string> = [];
    // constructor(type:string, field?:FieldDataInterface) {
    //   super(type, field);
    // }

    public serialize(): FieldDataInterface {
        return this._serialize({ values: this.values });
    }

    public deserialize(field: FieldDataInterface): SettingsDropdownSelectorV1Field {
        const self = new SettingsDropdownSelectorV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
        // Deserialize other properties using class's logic
        self.values = field.options.values;
        return self;
    }

    public update(updateData: Partial<SettingsDropdownSelectorV1Field>) : SettingsDropdownSelectorV1Field {
        // Create a new instance with the initial data
        const self = new SettingsDropdownSelectorV1Field(
            this.type,
            this.position,
            this.id,
            this.label,
            this.mandatory,
            this.active,
        );

        self.values = this.values;

        // Apply any updates provided in updateData
        if (updateData) {
            Object.assign(self, updateData);
            // mark the field as changed    
            self.changed = true;
        }
        return self;
    }
}
